<template>
  <section>
    <el-table
      ref="table"
      :data="list"
      style="width: 100%"
      highlight-current-row
      :header-row-class-name="'tableHeader'">
      <el-table-column
        label="Company"
        :show-overflow-tooltip="true"
        max-width="150">
        <template #default="{ row }">
          <div
            class="flex-algin"
          >
            <span>{{row.company}}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        label="Plan">
        <template #default="{ row }">
          <div
            v-for="(item,index) in row.reason"
            :key="'plan_'+index"
            class="flex-algin">
            <span class="text-span">{{ item.plan }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="Cause"
      >
        <template #default="{ row }">
          <div
            v-for="(item,index) in row.reason"
            :key="'plan_'+index"
            class="flex-algin">
            <span class="text-span">{{ item.detail }}</span>
          </div>
        </template>
      </el-table-column>

    </el-table>
  </section>
</template>

<script>
export default {
  name: 'cause-list',
  props:{
    list:{
      type:Array,
      default:()=>([])
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .tableHeader {
  margin-top: 30px;
  background: #F6F8FA !important;
  height: 45px;
  th {
    background-color:#F6F8FA !important;
    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    letter-spacing: -0.15px;
    color: #24292E;
    height: 45px;
    .cell{
      height: 30px;
    }
  }
}
.el-table{
  border-radius: 4px;
  border:1px solid #D1D5DA;
  ::v-deep .flex-algin{
    p,span{
      height: 24px;
    }
    .flex-circle{
      height: 24px;
      align-items: center;
      span{
        color: #24292E;
        font-size: 14px;
        font-weight: 600;
      }
    }
    p:first-child{
      color: #24292E;
      font-size: 14px;
      font-weight: 600;
      span{
        font-weight: 600;
      }
    }
  }
  .liter-time{
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    color: #24292E;
  }
  .liter-text{
    color: #6A737D;
    font-family: Inter;
    font-size: 12px;
    letter-spacing: 0;
    line-height: 15px;
  }
  .text-span{
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;
    color: #24292E;
  }
  ::v-deep .el-table-column--selection{
    .cell{
      padding-left: 15px!important;
    }
  }
  ::v-deep td{
    padding: 10px 0!important;
    vertical-align: top;
  }
  ::v-deep .el-checkbox:last-of-type{
    margin-top: 4px;
  }
}
</style>
